module.exports = __webpack_public_path__ + "static/media/19ESCAP3.5e23dfb6.jpg";